import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  FaChevronLeft,
  FaUser,
  FaLock,
  FaCog,
  FaBuilding,
  FaPhoneAlt,
  FaAddressCard,
} from 'react-icons/fa';

function SidebarSubmenu({ icon, text, children }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center px-3 py-2.5 rounded text-white hover:text-skin-primary hover:bg-skin-hover transition-colors w-full"
      >
        <span className="mr-3">{React.cloneElement(icon, { className: 'w-4 h-4' })}</span>
        <span className="app-text font-medium tracking-wide flex-1 text-left">{text}</span>
        <FaChevronLeft
          className={`w-3 h-3 transition-transform ${isOpen ? 'rotate-90' : '-rotate-90'}`}
        />
      </button>

      {isOpen && <div className="ml-7 mt-1 space-y-1">{children}</div>}
    </div>
  );
}

function Sidebar({ isOpen, onToggle }) {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex h-full app-text">
        <div
          className={`${isOpen ? 'w-[15vw]' : 'w-0'} transition-all duration-200 overflow-hidden flex-shrink-0 relative`}
          style={{ backgroundColor: '#191919' }}
        >
          {isOpen && (
            <button
              onClick={onToggle}
              className="absolute top-3 right-3 p-1 text-skin-secondary hover:text-skin-primary hover:bg-skin-hover rounded transition-colors"
            >
              <FaChevronLeft className="w-3 h-3" />
            </button>
          )}

          <div className="w-[15vw] h-full flex flex-col">
            <div className="flex-1 overflow-y-auto">
              <div className="px-2 py-1">
                {/* <SidebarLink icon={<FaHome />} text="Home" to="/" /> */}

                {/* Updated menu items in English */}
                <SidebarLink
                  icon={<FaBuilding />}
                  text={t('sidebar.community')}
                  to="/community-management"
                />
                <SidebarLink
                  icon={<FaLock />}
                  text={t('sidebar.electricLock')}
                  to="/lock-management"
                />
                <SidebarLink
                  icon={<FaUser />}
                  text={t('sidebar.sipAccount')}
                  to="/sip-account-management"
                />
                <SidebarSubmenu icon={<FaCog />} text={t('sidebar.settings')}>
                  <SidebarLink text={t('sidebar.roomSip')} to="/room-sip-account" />
                  <SidebarLink text={t('sidebar.staffSip')} to="/staff-sip-account" />
                  <SidebarLink text={t('sidebar.doorLock')} to="/door-lock-config" />
                </SidebarSubmenu>
                <SidebarLink
                  icon={<FaPhoneAlt />}
                  text={t('sidebar.callCenter')}
                  to="/call-center-management"
                />
                <SidebarLink
                  icon={<FaAddressCard />}
                  text={t('sidebar.ecardSetting')}
                  to="/ecard-setting"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Toggle Strip */}
        {!isOpen && (
          <div className="w-6 bg-skin-primary rounded-lg border-r border-[var(--border-color)] flex-shrink-0">
            <button
              onClick={onToggle}
              className="w-full h-[50px] flex items-center justify-center text-skin-secondary hover:text-skin-primary hover:bg-skin-hover rounded-tl-lg rounded-bl-lg"
            >
              <FaChevronLeft className="w-3 h-3 rotate-180" />
            </button>
          </div>
        )}
      </div>
    </>
  );
}

function SidebarLink({ icon, text, to }) {
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <Link
      to={to}
      className={`flex items-center px-3 py-2.5 rounded transition-colors w-full ${
        isActive
          ? 'bg-blue-100 text-blue-900 font-semibold'
          : 'text-white hover:text-skin-primary hover:bg-skin-hover'
      }`}
    >
      {icon && <span className="mr-3">{React.cloneElement(icon, { className: 'w-4 h-4' })}</span>}
      <span className="app-text tracking-wide">{text}</span>
    </Link>
  );
}

export default Sidebar;
